<template>
  <div>
    <p style="text-align=center;font-size:18px">
      <span class="systemFont0">{{ $t('pointsRule.title') }}</span>
    </p>
    <div style="padding-bottom: 40px;">
      <div>
        <el-form :model="pointRuleForm" label-position="left" ref="rewardFormRef" label-width="0px"
          hide-required-asterisk>
          <!--注册公司账户积分  -->
          <div class="borderColor">
            <div class="headBorderColor">
              <p style="margin-left:30px;margin-top:11.5px">{{ $t('pointsRule.company') }}</p>
            </div>
            <el-form-item prop="companyPoint" :rules="almostPointsRule">
              <p class="textStyle">{{ $t('pointsRule.companyPoint') }}
                <el-input v-model="pointRuleForm.companyPoint" class="inputFormat1" size="reportContentInput"
                  maxlength="3"></el-input>
                {{ $t('pointsRule.TQSPoints') }}
              </p>
            </el-form-item>
            <el-form-item>
              <p class="textStyle">{{ $t('pointsRule.countryTitle') }}</p>
            </el-form-item>
            <el-row class="textStyleAdd" v-for="(countryItem, index) in pointRuleForm.country" :key="index">
              <el-col style="width: 260px;">
                <el-form-item>
                  {{ $t('pointsRule.register') }}
                  <el-select @change="selecte()" :placeholder="$t('pointsRule.selectCountry')"
                    v-model="pointRuleForm.country[index].country"
                    style="width:120px;padding-left:10px;padding-right:10px" size="reportContentInput"
                    clearable>
                    <el-option v-for="item in countrySettingList" :key="item.index" :label="item.country"
                      :value="item.index" :disabled="item.disabled">
                    </el-option>
                  </el-select>
                  {{ $t('pointsRule.countryPoints') }}
                </el-form-item>
              </el-col>
              <el-col style="width: 205px;">
                <el-form-item :prop="`country.${index}.countryPoint`" :rules="countryItem.country != null && countryItem.country != '' ? almostPointsRule : almostPointsRule2" class="error-layout">
                  {{ $t('pointsRule.user') }}
                  <el-input v-model="pointRuleForm.country[index].countryPoint" class="inputFormat"
                    size="reportContentInput" maxlength="3"
                    ></el-input>
                  {{ $t('pointsRule.TQSPoints') }}
                  <img v-if="index == 0" class="add-icon" src="@/assets/add.svg" @click="add()" />
                  <img v-if="index != 0" class="subtract-icon" src="@/assets/subtract.svg" @click="subtract(index)" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--使用8DReport积分-->
          <div class="borderColor">
            <div class="headBorderColor">
              <p style="margin-left:30px;">{{ $t('pointsRule.points8D') }}</p>
            </div>
            <el-form-item prop="pointD8" :rules="almostPointsRule">
              <p class="textStyle">{{ $t('pointsRule.D8Points') }}
                <el-input v-model="pointRuleForm.pointD8" class="inputFormat" size="reportContentInput"
                  maxlength="3"></el-input>
                {{ $t('pointsRule.TQSPoints') }}
              </p>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap">
              <div style="width: 500px;">
                <el-form-item prop="pointD1" :rules="almostPointsRule">
                  <p class="textStyle">{{ $t('pointsRule.D1Points') }}
                    <el-input v-model="pointRuleForm.pointD1" class="inputFormat" size="reportContentInput"
                      maxlength="3"></el-input>
                    {{ $t('pointsRule.TQSPoints') }}
                  </p>
                </el-form-item>
              </div>
              <div style="width: 500px;">
                <el-form-item prop="sharePoint8D" :rules="almostPointsRule">
                  <p class="textStyle">{{ $t('pointsRule.share8DPoints') }}
                    <el-input v-model="pointRuleForm.sharePoint8D" class="inputFormat" size="reportContentInput"
                      maxlength="3"></el-input>
                    {{ $t('pointsRule.TQSPoints') }}
                  </p>
                </el-form-item>
              </div>
            </div>
          </div>
          <!--使用质量工具积分  -->
          <div class="borderColor">
            <div class="headBorderColor">
              <p style="margin-left:30px;margin-top:11.5px">{{ $t('pointsRule.qualityToolPoints') }}</p>
            </div>
            <el-form-item prop="pointFish" :rules="almostPointsRule">
              <p class="textStyle">{{ $t('pointsRule.fishPoints') }}
                <el-input v-model="pointRuleForm.pointFish" class="inputFormat" size="reportContentInput"
                  maxlength="3"></el-input>
                {{ $t('pointsRule.TQSPoints') }}
              </p>
            </el-form-item>
            <el-form-item prop="point5W2H" :rules="almostPointsRule">
              <p class="textStyle">{{ $t('pointsRule.points5W2H') }}
                <el-input v-model="pointRuleForm.point5W2H" class="inputFormat" size="reportContentInput"
                  maxlength="3"></el-input>
                {{ $t('pointsRule.TQSPoints') }}
              </p>
            </el-form-item>
            <el-form-item prop="point5Why" :rules="almostPointsRule">
              <p class="textStyle">{{ $t('pointsRule.points5WHY') }}
                <el-input v-model="pointRuleForm.point5Why" class="inputFormat" size="reportContentInput"
                  maxlength="3"></el-input>
                {{ $t('pointsRule.TQSPoints') }}
              </p>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap">
              <div style="width: 421px;">
                <el-form-item prop="pointIsNot" :rules="almostPointsRule">
                  <p class="textStyle">{{ $t('pointsRule.pointsIN') }}
                    <el-input v-model="pointRuleForm.pointIsNot" class="inputFormat" size="reportContentInput"
                      maxlength="3"></el-input>
                    {{ $t('pointsRule.TQSPoints') }}
                  </p>
                </el-form-item>
              </div>
              <div style="width: 500px;">
                <el-form-item prop="sharePointTool" :rules="almostPointsRule">
                  <p class="textStyle">{{ $t('pointsRule.shareTools') }}
                    <el-input v-model="pointRuleForm.sharePointTool" class="inputFormat" size="reportContentInput"
                      maxlength="3"></el-input>
                    {{ $t('pointsRule.TQSPoints') }}
                  </p>
                </el-form-item>
              </div>
            </div>
          </div>
          <!--使用绿夹克讲坛积分  -->
          <div class="borderColor">
            <div class="headBorderColor">
              <p style="margin-left:30px;margin-top:11.5px">{{ $t('pointsRule.greenJacketPoints') }}</p>
            </div>
            <div style="display: flex;flex-wrap: wrap">
              <el-row>
                <el-col style="width: 246px;">
                  <el-form-item prop="pointGJF" :rules="almostPointsRule">
                    <p class="textStyle">{{ $t('pointsRule.GJFPoints') }}
                      <el-input maxlength="3" v-model="pointRuleForm.pointGJF" class="inputFormat"
                        size="reportContentInput"></el-input>
                    </p>
                  </el-form-item>
                </el-col>
                <el-col style="width: 266px;">
                  <el-form-item prop="coefficient" :rules="coefficientRule">
                    <p class="textStyle" style="padding-left: 0px">{{ $t('pointsRule.coefficient') }}
                      <el-input v-model="pointRuleForm.coefficient" class="inputFormat" size="reportContentInput"
                        maxlength="4"></el-input>
                      {{ $t('pointsRule.coefficientTQSPoints') }}
                    </p>
                  </el-form-item>
                </el-col>
                <el-col style="width: 440px;">
                  <el-form-item>
                    <p class="textStyle" style="font-size: 12px; color: #0085E6;">{{ $t('pointsRule.ps') }}</p>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-form-item prop="pointCoupon" :rules="almostPointsRule">
              <p class="textStyle">{{ $t('pointsRule.pointCoupon') }}
                <el-input v-model="pointRuleForm.pointCoupon" class="inputFormat" size="reportContentInput"
                  maxlength="3"></el-input>
                {{ $t('pointsRule.TQSPoints') }}
              </p>
            </el-form-item>
          </div>
          <el-row class="foot-container">
            <el-button type="submit" @click.native.prevent="submit()">{{ $t('pointsRule.submit') }}</el-button>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      oldPointRuleForm: '',
      pointRuleForm: {
        companyPoint: "",
        country: [{
          country: '',
          countryPoint: '',
          index: '',
        }],
        pointD8: "",
        pointD1: "",
        sharePoint8D: "",
        pointFish: "",
        point5W2H: "",
        point5Why: "",
        pointIsNot: "",
        sharePointTool: "",
        pointGJF: "",
        coefficient: "",
        pointCoupon: "",
      },
      // 提交的数据
      submitForm: {},
      // 国家列表
      countrySettingList: [
        {
          country: '',
          countryPoint: '',
          index: '',
          disabled: false,
        },
      ],
      optionList: [
        {
          country: '',
          countryPoint: '',
          index: '',
        },
      ],
      countryList: [],
      // 只能输入正整数
      almostPointsRule: [
        {
          required: true,
          pattern: /^[1-9]\d*$/,
          message: this.$t('pointsRule.almostPointsRule'),
          trigger: "blur",
        },
      ],
      // 只能输入正整数,不是必填
      almostPointsRule2: [
        {
          pattern: /^[1-9]\d*$/,
          message: this.$t('pointsRule.almostPointsRule'),
          trigger: "blur",
        },
      ],
      // 只能输入0到100的整数或者一位小数
      coefficientRule: [
        {
          required: true,
          pattern: /^(([1-9]?\d{0,1}(\.\d{1})?)|100|100\.(0){1})$/,
          message: this.$t('pointsRule.coefficientRule'),
          trigger: "blur",
        },
      ],
    }
  },
  methods: {
    // 初始化
    init() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/EncourageRules/init";
      this.$http
        .post(url)
        .then(response => {
          if (response.data.code === 200) {
            this.pointRuleForm = response.data.data;
            this.oldPointRuleForm = JSON.parse(JSON.stringify(this.pointRuleForm))
            this.countrySettingList = response.data.data.countrySettingList.map(item => {
              return { ...item, disabled: false }
            });
            this.selecte()
            loading.close();
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 增加选择国家
    add() {
      if (this.pointRuleForm.country.length == this.countrySettingList.length) {
        return
      }
      this.pointRuleForm.country.push({
        country: "",
        countryPoint: "",
        index: "",
      })
      this.selecte()
    },
    // 删除选择国家
    subtract(index) {
      this.pointRuleForm.country.splice(index, 1)
      this.selecte()
    },
    // 提交
    submit() {
      this.$refs["rewardFormRef"].validate(valid => {
        if (this.contentChangQS()) {
          return
        }
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let url = "/api/EncourageRules/submit"
          this.comparePoints();
          this.$http
            .post(url, ({
              companyPoint: this.pointRuleForm.companyPoint,
              pointD8: this.pointRuleForm.pointD8,
              pointD1: this.pointRuleForm.pointD1,
              sharePoint8D: this.pointRuleForm.sharePoint8D,
              pointFish: this.pointRuleForm.pointFish,
              point5W2H: this.pointRuleForm.point5W2H,
              point5Why: this.pointRuleForm.point5Why,
              pointIsNot: this.pointRuleForm.pointIsNot,
              sharePointTool: this.pointRuleForm.sharePointTool,
              pointGJF: this.pointRuleForm.pointGJF,
              coefficient: this.pointRuleForm.coefficient,
              pointCoupon: this.pointRuleForm.pointCoupon,
              country: this.pointRuleForm.country,
            }))
            .then(response => {
              if (response.data.code === 200) {
                console.log(response.data.data);

                loading.close();
                this.init();
                this.$message.success(this.$t("pointsRule.submitSuccessfully"));
              }
            })
            .catch(err => {
              loading.close();
              this.init();
              console.log(err);
              this.$message.error(this.$t("pointsRule.submitfailed"));
            });
        }
      });
    },
    // 提交时的数据对比
    comparePoints() {
      if (this.pointRuleForm.companyPoint == this.oldPointRuleForm.companyPoint) {
        this.pointRuleForm.companyPoint = null
      }
      if (this.pointRuleForm.pointD8 == this.oldPointRuleForm.pointD8) {
        this.pointRuleForm.pointD8 = null
      }
      if (this.pointRuleForm.pointD1 == this.oldPointRuleForm.pointD1) {
        this.pointRuleForm.pointD1 = null
      }
      if (this.pointRuleForm.sharePoint8D == this.oldPointRuleForm.sharePoint8D) {
        this.pointRuleForm.sharePoint8D = null
      }
      if (this.pointRuleForm.pointFish == this.oldPointRuleForm.pointFish) {
        this.pointRuleForm.pointFish = null
      }
      if (this.pointRuleForm.pointD8 == this.oldPointRuleForm.pointD8) {
        this.pointRuleForm.pointD8 = null
      }
      if (this.pointRuleForm.point5W2H == this.oldPointRuleForm.point5W2H) {
        this.pointRuleForm.point5W2H = null
      }
      if (this.pointRuleForm.point5Why == this.oldPointRuleForm.point5Why) {
        this.pointRuleForm.point5Why = null
      }
      if (this.pointRuleForm.pointIsNot == this.oldPointRuleForm.pointIsNot) {
        this.pointRuleForm.pointIsNot = null
      }
      if (this.pointRuleForm.sharePointTool == this.oldPointRuleForm.sharePointTool) {
        this.pointRuleForm.sharePointTool = null
      }
      if (this.pointRuleForm.pointGJF == this.oldPointRuleForm.pointGJF) {
        this.pointRuleForm.pointGJF = null
      }
      if (this.pointRuleForm.coefficient == this.oldPointRuleForm.coefficient) {
        this.pointRuleForm.coefficient = null
      }
      if (this.pointRuleForm.pointCoupon == this.oldPointRuleForm.pointCoupon) {
        this.pointRuleForm.pointCoupon = null
      }
    },
    // 内容变更判断
    contentChangQS() {
      if (
        JSON.stringify(this.oldPointRuleForm) === JSON.stringify(this.pointRuleForm)
      ) {
        this.$message({
          message: this.$t("p0213.contentIsUnchanged"),
          type: "warning",
        });
        return true;
      }
      return false;
    },
    // 限制下拉框选项
    selecte() {
      this.optionList = []
      console.log('select', this.optionList, this.pointRuleForm.country, this.countrySettingList)
      for (let i = 0; i < this.countrySettingList.length; i++) {
        let flag = 0;
        for (let j = 0; j < this.pointRuleForm.country.length; j++) {
          console.log('equal', this.pointRuleForm.country[j], this.countrySettingList[i])
          if (this.pointRuleForm.country[j].country == this.countrySettingList[i].index)
            flag = 1;
        }
        console.log('flag', flag)
        if (flag) {
          // this.optionList.push({...this.countrySettingList[i]});
          // console.log(this.countrySettingList.country);
          this.$set(this.countrySettingList[i], 'disabled', true)
        } else {
          this.$set(this.countrySettingList[i], 'disabled', false)
        }
      }
      // console.log('select',this.optionList)
    },
  },
  mounted() {
    this.init()
  },

}
</script>

<style lang="scss" scoped>
.headBorderColor {
  border: 1px solid;
  border-color: transparent transparent #cccccc transparent;
  height: 48px;
  background-color: rgba(250, 250, 250, 1);
  margin: auto;
  text-align: left;
  color: #0085E6;
  font-size: 17px;
}

.borderColor {
  border: 1px solid #cccccc;
  width: 70%;
  margin: 20px auto 0px auto;
}

.textStyle {
  text-align: left !important;
  padding-left: 20px;
  font-size: 13px;
  height: 40px;
  // margin-top: 0px;
  // margin: 0px
}

.textStyleAdd {
  text-align: left !important;
  padding: 13px 0 13px 20px;
  font-size: 13px;
  height: 66px;
}

// 输入框样式
.inputFormat {
  text-align: center;
  width: 60px;
  padding-left: 10px;
  padding-right: 10px;
}

.inputFormat1 {
  text-align: center;
  width: 60px;
  padding-left: 10px;
  padding-right: 10px;
  height: 20px;
}

>>>.el-input__icon {
  line-height: 0px
}

.el-select-dropdown__item.selected {
  font-weight: normal;
  color: #606266 !important;
}

// 加号图标的样式
.add-icon {
  padding-left: 10px;
  cursor: pointer;
  vertical-align: middle;
}

// 减号图标的样式
.subtract-icon {
  padding-left: 10px;
  cursor: pointer;
  vertical-align: middle;
}

>>>.el-form-item {
  margin-bottom: 0px;
}

.foot-container {
  margin: 20px auto 0 auto;
  height: 26px;
  width: 14%;
  text-align: center;
}

>>>.el-form-item__error {
  left: 20px;
  top: 45px;
}

.error-layout>>>.el-form-item__error {
  left: 0px;
  top: 35px;
}

@media screen and (max-width: 1600px) {
  .borderColor {
    width: 90%;
  }
}

// 下拉框清除按钮位置
>>> .el-input__icon {
  line-height: unset;
}

</style>


// WEBPACK FOOTER //
// src/views/Marketing/IncentiveRules/P0421.vue